module.exports = __webpack_public_path__ + "img/block_bg_6_1.6f587906.png";